export const messages = {
  my_files: "我的文件",
  user_guide: "使用指南",
  connect_wallet: "连接钱包",
  home_title: "NFT Hub",
  home_sub_title: "保存你重要的NFT内容，去中心化且免费",
  powered_by: "Powered by",
  upload: "上传",
  download: "下载",
  gallery: "画廊",
  step: "步骤",
  step1_description:
    "下载并安装 TronLink 钱包 并使用钱包创建或导入您的 Tron 账户",
  step2_description: "点击 connect wallet 按钮，授权并登录 NFT Hub",
  step3_description_part1: "上传您的 NFT 内容文件，成功后可在 ",
  step3_description_part2: "中查看并获取内容地址链接，并可一键铸造NFT",
  partners: "合作伙伴",
  connect_wallet_description: "请连接钱包以开始使用 NFT Hub",
  tronlink_not_installed: "TronLink没有安装",
  tronlink_not_login: "未登录TronLink?",
  connect_tronlink: "连接TronLink",
  no_tronlink: "没有安装TronLink？",
  login_first: "请先登录TronLink钱包",
  install_first: "请先安装TronLink钱包",
  to_install: "去安装",
  login_already: "已经登录",
  limit_exceed: "超出限额",
  limit_description:
    "当前每个Tron地址仅限上传 30 个文件，若您为开发者，或有更多文件存储需求，欢迎通过下面邮箱地址请联系我们",
  upload_successful: "上传成功",
  upload_failed: "上传失败",
  download_failed: "下载失败",
  copied: "已复制!",
  file_name: "文件名称",
  file_hash: "内容地址",
  size: "文件大小",
  type: "类型",
  total: "总数",
  type_not_supported: "类型不支持",
  size_warning: "不能超过30M",
  created_date: "创建时间",
  copy_link: "复制地址",
  coming_soon: "敬请期待",
  mint_description: "一键铸造NFT功能开发中，敬请期待",
  mint_nft: "铸造NFT",
  go_to: "跳转",
  logout: "退出登录",
  upload_description1:
    "点击按钮或拖拽文件，来选择你想要上传到BTFS网络中的文件。",
  upload_description2: "文件最大尺寸为30M，一次仅可上传一个文件。",
  upload_type: "文件类型支持： ",
  upload_double_check: "上传前请再次确认，该操作无法撤销。",
  add: "添加文件",
  etc: "等等",
  no_preview: "不支持此文件类型预览",
  ecosystem: "生态",
  developer: "开发",
  community: "社区",

  // v1.1 justinsnft

  justins_nft_description: "了解 Justin 在BTFS上分享的精彩内容",
  collections: "收藏",
  works: "作品",
  reports: "报道",
  loading: "有一个下载中的文件，请下载完成后再继续下载",

  // v1.1 mint

  asset: "资产",
  name: "名称",
  category: "类别",
  description: "描述",
  description_sub: "对于该内容的描述",
  outerlink: "外部链接",
  is_original: "是否原创",
  is_original_sub: "如果文件为您的原创内容，请勾选",
  is_sensible: "露骨的和敏感内容",
  is_sensible_sub: "如果文件包含露骨和敏感内容，请勾选",
  sensible_tip:
    "将您的资产设置为露骨而敏感的内容，例如色情内容和其他不适合在工作场合浏览的内容",
  blockchain: "区块链",
  blockchain_sub: "选择NFT将要铸造的公链，未来NFT将会支持更多公链",
  blockchain_tip: "",
  contract: "智能合约",
  contract_sub: "选择NFT将要铸造的合约，未来NFThub将会支持更多合约",
  contract_tip: "",
  change_owner: "更改NFT拥有者",
  change_owner_sub: "如果不更改拥有者，则默认当前地址为新创建的NFT的拥有者",
  mint: "铸造",
  waiting_for_confirm: "等待钱包确认",
  mint_successful: "铸造成功",
  mint_error: "铸造失败, 请确保有足够的TRX来支付带宽与能量",
  minting: "文件铸造中，请稍后查看",
  unMint: "该文件没有关联的NFT",
  image: "图像",
  audio: "音频",
  video: "视频",
  document: "文档",
  code: "代码",
  "3d": "3D模型",
  collection: "收藏品",
  others: "其他",
  NFT_name_null: "名称不能为空",
  NFT_category_null: "类别不能为空",
  NFT_invalid_chain: "钱包所连接的区块链与合约所在的区块链不一致",
  NFT_invalid_owner: "无效地址",
  related_contract: "文件关联的NFT合约",
  contract_future: "NFT Hub 未来支持更多公链和合约，以及更多玩法",
  view: "查看",
  NFT_on_chain: "您的NFT已上链",
  ok: "好的",
  add_to_link: "添加NFT到Tronlink",
  name_address: "文件名称 & 地址",
  other_operations: "操作",

    // new add in files
    mint_view: "查看NFT",
    mint_sell: "出售NFT",
    sell_own: "出售",
    price: "价格",
    expiration_date: "过期日期",
    fees: "费率",
    fees_des: "以下费用将在出售时被扣除",
    APENFT_service_fee: "APENFT服务费",
    copyright_fee: "版权费",
    total_fees: "总费用",
    listing_btn: "上架",
    listing_successful: "上架成功！",
    listing_failed: "上架失败！",
    already_listed: "已上架",
    price_error_1: "数值必须不小于1",
    price_error_2: "余额不足",
    price_error_3: "数字过大",
    expiration_error_1: "过期时间无效",
    approve_collection: "合集授权",
    confirm_listing: "上架确认",
    approve_collection_des: "第一次上架出售前，您需要批准APENFT可以交易该NFT，这需要付一次Gas费。",
    approve_des: "第一次交易前，您需要授权交易，这需要付一次Gas费。",
    confirm_des: "请在钱包中确认交易并等待交易完成。",
    listing: "上架",
    approve: "授权",
    failed: "失败！",
    retry: "重试",
};
